import { apiJson } from '@/api/client'
import type {
  AcknowledgePayload,
  HandoverDetail,
  HandoverListFilters,
  HandoverListResponse,
  SaveDraftPayload,
  ShiftSummary,
  SubmitHandoverPayload,
} from './types'

function paramsFor(f: HandoverListFilters = {}): string {
  const sp = new URLSearchParams()
  if (f.date_from) sp.set('date_from', f.date_from)
  if (f.date_to) sp.set('date_to', f.date_to)
  for (const t of f.team ?? []) sp.append('team', t)
  for (const u of f.user_id ?? []) sp.append('user_id', u)
  for (const s of f.status ?? []) sp.append('status', s)
  const s = sp.toString()
  return s ? `?${s}` : ''
}

export function getShiftSummary() {
  return apiJson<ShiftSummary>('/handovers/shift-summary')
}

export function listHandovers(filters: HandoverListFilters = {}) {
  return apiJson<HandoverListResponse>(`/handovers${paramsFor(filters)}`)
}

export function getHandover(id: string) {
  return apiJson<HandoverDetail>(`/handovers/${id}`)
}

export function saveDraft(payload: SaveDraftPayload) {
  return apiJson<{ handover: HandoverDetail }>(`/handovers/draft`, {
    method: 'PUT',
    body: payload,
  })
}

export function submitHandover(payload: SubmitHandoverPayload) {
  return apiJson<{ handover: HandoverDetail }>(`/handovers/${payload.id}/submit`, {
    method: 'POST',
  })
}

export function acknowledgeHandover(payload: AcknowledgePayload) {
  return apiJson<{ handover: HandoverDetail }>(
    `/handovers/${payload.id}/acknowledge`,
    { method: 'POST', body: { comment: payload.comment ?? null } },
  )
}
